import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
  Button,
  Text,
} from "@coreai/component-library";
import { useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";

interface DeleteAnalysesDialogProps {
  analysis: any;
  open: boolean;
  onClose: () => void;
  onDelete: (id: string) => void;
}

export default function DeleteAnalysesDialog(
  props: Readonly<DeleteAnalysesDialogProps>
) {
  const { t } = useLanguage();
  const theme = useTheme();

  const alertDialogBodyStyles = {
    border: "none",
  } as React.CSSProperties;

  const bodyStyles = {
    fontFamily: theme.typography.bodyMedium.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    fontWeight: theme.typography.bodyMedium.fontWeight,
    lineHeight: theme.typography.bodyMedium.lineHeight,
    color: theme.colors.textDark,
    marginBottom: theme.spacing.sm,
    paddingTop: 0,
    overflowY: "visible",
    gap: "1.5rem",
  } as React.CSSProperties;
  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(isOpen) => !isOpen && props.onClose()}
    >
      <AlertDialogContent size="sm">
        <AlertDialogHeader style={alertDialogBodyStyles}>
          <AlertDialogTitle>
             {t("analysis_remove_title")}
          </AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogBody style={bodyStyles}>
          <Text style={bodyStyles}>          
            {t("analysis_remove_inlineInformation_text")} {` "${props?.analysis?.name}"?`}
          </Text>
        </AlertDialogBody>

        <AlertDialogFooter style={alertDialogBodyStyles}>
          <AlertDialogCancel asChild>
            <Button variant="tertiary">{t("core_cancel")}</Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant={"brand"}
              style={{ backgroundColor: theme.colors.primary }}
              onClick={() => props.onDelete(props.analysis.id)}
            >
              {t("core_delete")}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
